import React from 'react';
import { FaIdCard } from 'react-icons/fa';

const DataSIM = ({ total }) => {
  return (
    <>
      <div className='flex items-center justify-start gap-3 rounded-[10px] bg-amber-700 p-2 md:p-4'>
        <div className='flex p-2 items-center justify-center rounded-full bg-white'>
          <FaIdCard size={28} color='#b45309' />
        </div>

        <div className='flex items-end justify-between'>
          <div>
            <h4 className='-mb-1.5 text-2xl font-bold text-white'>{total}</h4>
            <span className='text-body-sm font-medium text-gray-300'>
              Jumlah Pemohon Psikologi SIM
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default DataSIM;
